<template>
  <div class="menu-card" @mouseenter="isHovered = true" @mouseleave="isHovered = false" @click="handleClick">
    <div class="menu-card__image-wrapper">
      <img class="menu-card__image" :src="image" :alt="$t('menuCard.title')" />
    </div>

    <div class="menu-card__content">
      <div class="menu-card__text-wrapper">
        <span>{{ $t("menuCard.title") }}</span>
        <p>{{ $t("menuCard.description") }}</p>
      </div>
      <veneta-icon :is-hovered="isHovered" />
    </div>
  </div>
</template>

<script setup>
import image from "~/assets/images/menu-card.jpg";

const { t } = useI18n();
const isHovered = ref(false);

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
.menu-card {
  background-color: var(--color-white);
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  height: 267px;
  cursor: pointer;

  // max-width: 590px;

  @include up-to-tablet {
    height: auto;
  }

  &__image-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;

    @include up-to-tablet {
      display: none;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    // max-width: 356px;

    .menu-card:hover & {
      transform: scale(1.1);
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 27.5px 36px;
    justify-content: space-between;

    @include up-to-tablet {
      padding: 16px;
      padding-left: var(--space-n);
      padding-right: var(--space-n);
      flex-direction: row;
      align-items: end;
    }

    span {
      color: var(--color-ted, #dc0814);
      font-size: var(--typography-size-xs-desktop);
      font-style: normal;
      font-weight: 500;
      line-height: 160%; /* 25.6px */
      text-transform: uppercase;
    }

    p {
      color: #000;
      font-size: var(--typography-size-m-desktop);
      font-style: normal;
      font-weight: 400;
      line-height: 160%; /* 32px */
      width: 200px;

      @include up-to-tablet {
        width: 100%;
      }
    }
  }

  &__text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    @include up-to-tablet {
      flex: 1;
    }
  }
}
</style>
